import axios from "axios";

axios.defaults.headers.timeout = 1000 * 60;
//axios.defaults.baseURL = 'http://192.168.0.36:8080';//http://192.168.0.36:8080  http://47.92.208.0:8080
let baseURL = 'http://47.92.208.0:8080';
let baseURL1 = 'http://api.farm.0531yun.cn';
let baseURL2 = 'http://182.40.36.93:8900/iotservice/insect';

axios.interceptors.request.use(
  (config) => {
    switch (config.urlType) {
      case 'meteSoil':
        config.url = baseURL + config.url;

        config.headers={
          'Content-Type':'application/json',
          'Accept': 'application/json'
        };

        //let token = localStorage.getItem('token');
        let token = localStorage.getItem('token') == null ? null : tokenDec(localStorage.getItem('token'));
        if(token && token != '') {
          const token_type="Bearer";
          config.headers['X-Authorization'] = token_type + ' ' + token;
        }
        break;
      case 'sporePest':
        config.url = baseURL1 + config.url;

        config.headers={
          'Content-Type':'application/json',
          'Accept': 'application/json'
        };

        //let spToken = localStorage.getItem('spToken');
        let spToken = localStorage.getItem('spToken') == null ? null : tokenDec(localStorage.getItem('spToken'));
        if(spToken && spToken != '') {
          config.headers['token'] = spToken;
        }
        break;
      case 'insectPest':
        config.url = baseURL2 + config.url;
        config.headers={
          'Content-Type':'application/json',
          'Accept': 'application/json'
        };
        break;
    }

    console.log("url", config.url);
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error)
  }
);

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.log(error.response);
    if(error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误';
          break;
        case 401:
          error.message = '未授权请重新登录';
          window.location.href='#/';
          break;
        case 403:
          error.message = '拒绝访问';
          break;
        case 404:
          error.message = '请求错误，未找到资源';
          window.location.href = "/NotFound";
          break;
        case 405:
          error.message = '请求方法不允许';
          break;
        case 408:
          error.message = '请求超时';
          break;
        case 501:
          error.message = '网络未实现';
          break;
        case 502:
          error.message = '网络错误';
          break;
        case 503:
          error.message = '服务不可用';
          break;
        case 504:
          error.message = '网络超时';
          break;
        case 505:
          error.message = 'http版本不支持该请求';
          break;
        default:
          error.message = `连接错误${error.response.status}`;
          break;
      }
    } else {
      if(JSON.stringify(error).includes('timeout')) {
        console.log('服务器响应超时，请刷新当前页面');
      }
      error.message = '连接服务器失败'
    }
    return Promise.reject(error);
  }
);

function tokenDec(code) {
  code = unescape(code);
  let c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for(let i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}

export default axios



// WEBPACK FOOTER //
// ./src/until/http.js